import { OTPSelectVerificationTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const OTPSelectVerificationTrackingSchema: Record<
  OTPSelectVerificationTrackingPoint,
  {
    schema: string;
    target_type?: string;
  }
> = {
  [OTPSelectVerificationTrackingPoint.PageView]: {
    schema: '1805a7bb-24b3-4527-8cab-3e34332dc5c8',
  },
  [OTPSelectVerificationTrackingPoint.CallButtonClick]: {
    schema: '807c93fd-b8f8-43d0-b4ca-1413c04847f4',
    target_type: 'phone_call_button',
  },
  [OTPSelectVerificationTrackingPoint.SmsButtonClick]: {
    schema: '9ffad3a6-f702-4e76-a861-79f0df3c1992',
    target_type: 'send_sms_button',
  },
  [OTPSelectVerificationTrackingPoint.WhatsAppButtonClick]: {
    schema: '8c86f4e3-a1e9-46cf-b78d-0a873a8e77a5',
  },
  [OTPSelectVerificationTrackingPoint.BackButtonClick]: {
    schema: 'df2411bb-89c9-467a-9d49-5aa7e85ce4b0',
  },
  [OTPSelectVerificationTrackingPoint.HelpButtonClick]: {
    schema: '47924235-f834-4aa4-bbad-bb420c01139e',
  },
  [OTPSelectVerificationTrackingPoint.ViberButtonClick]: {
    schema: 'c802d6ce-04ce-4c0b-baf7-d707e7a4c0c0',
  },
  [OTPSelectVerificationTrackingPoint.ZaloButtonClick]: {
    schema: 'ae91bc92-6aae-4c31-9455-1b199afa1eb5',
  },
};

export const getOTPSelectVerificationPageTypeAndSchema = (
  trackingPoint: OTPSelectVerificationTrackingPoint
) => {
  const { schema, target_type } = OTPSelectVerificationTrackingSchema[
    trackingPoint
  ];

  const params: {
    page_type: string;
    schema: string;
    target_type?: string;
  } = {
    page_type: PageType.OTPSelectVerificationMethodPage,
    schema,
  };
  if (target_type) {
    params.target_type = target_type;
  }
  return params;
};
